import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import uiIcons from "./uiIcons";
import {
  DUOTONE_OPACITY,
  ICON_VIEWBOX,
  gridPath,
  findDuotoneSecondary,
} from "../../utils/svgIcon";

// Inline SVG on the 24x24 grid, sized at 1em and sitting on the text baseline like a
// font glyph, so font-size and color on the icon or its parent drive it.
export const Svg = ({ path, pathSecondary, className, ...rest }) => (
  <svg
    className={className ? `glyph ${className}` : "glyph"}
    viewBox={ICON_VIEWBOX}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path d={path} />
    {pathSecondary ? (
      <path d={pathSecondary} opacity={DUOTONE_OPACITY} />
    ) : null}
  </svg>
);

Svg.propTypes = {
  path: PropTypes.string.isRequired,
  pathSecondary: PropTypes.string,
  className: PropTypes.string,
};

/**
 * One of the site's own icons by name (see scripts/build-ui-icons.js),
 * e.g. <UiIcon name="close-line" /> or <UiIcon name="duotone:archive" />
 */
export const UiIcon = ({ name, ...rest }) => {
  const svg = uiIcons[name];
  if (!svg) return null;
  return <Svg path={svg.path} pathSecondary={svg.pathSecondary} {...rest} />;
};

UiIcon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

/** An icon entity from the store, including both layers of duotone icons */
const EntityIconBase = ({ entity, secondary, dispatch, ...rest }) =>
  entity && entity.svg ? (
    <Svg
      path={gridPath(entity.svg)}
      pathSecondary={secondary ? gridPath(secondary.svg) : null}
      {...rest}
    />
  ) : null;

EntityIconBase.propTypes = {
  entity: PropTypes.object,
  secondary: PropTypes.object,
  className: PropTypes.string,
  dispatch: PropTypes.func,
};

export const EntityIcon = connect((store, { entity }) => ({
  secondary: findDuotoneSecondary(store.localstore.icons, entity),
}))(EntityIconBase);

export default UiIcon;
